module.exports = __webpack_public_path__ + "vue/img/logo6.a2997648.png";